<div mat-dialog-content>
  <div class="text-right">
    <button mat-mini-fab color="primary" class="small-button m-0" appTooltip="Télécharger le QRCode">
      <a [href]="propHelper.getQrCodeImage(data.prop.uid)" [download]="data.prop.name + '_QRCode.png'"
        class="text-white">
        <mat-icon aria-label="Télécharger le QRCode">download_for_offline</mat-icon>
      </a>
    </button>
  </div>
  <div class="qrcode">
    <img class="img-fluid" width="240" [src]="propHelper.getQrCodeImage(data.prop.uid)" alt="QRCode du bien" />
  </div>
  <div class="text-center">
    <button mat-flat-button class="m-2" color="primary" mat-dialog-close (click)="onNoClick()">
      Fermer
    </button>
  </div>
</div>
